import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { paymentApi } from '@formosa/shared/api/payment';
import { useTranslation } from '../../i18n/LocaleContext';

export default function WithdrawMethodsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [categories, setCategories] = useState([]);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const list = await paymentApi.listWithdrawMethodCategories();
      setCategories(Array.isArray(list) ? list : []);
    } catch (err) {
      setError(err.message || t('withdraw.loadFailed'));
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  function handleSelectCategory(category) {
    navigate('/withdraw/addresses', {
      state: {
        categoryKey: category.categoryKey,
        categoryLabel: category.label,
        from: location.state?.from || '/withdraw',
      },
    });
  }

  return (
    <div className="deposit-page withdraw-methods-page">
      <header className="deposit-page__header">
        <button
          type="button"
          className="deposit-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(location.state?.from || '/withdraw')}
        >
          ‹
        </button>
        <h1>{t('withdraw.methodsTitle')}</h1>
        <span className="deposit-page__header-spacer" />
      </header>

      {loading && <p className="deposit-page__status">{t('common.loading')}</p>}
      {error && <p className="deposit-page__error">{error}</p>}

      {!loading && !error && (
        <ul className="deposit-currency-list">
          {categories.length === 0 ? (
            <li className="deposit-page__empty">{t('withdraw.noMethodCategory')}</li>
          ) : (
            categories.map((category) => (
              <li key={category.categoryKey}>
                <button
                  type="button"
                  className="deposit-currency-item"
                  onClick={() => handleSelectCategory(category)}
                >
                  <span className="deposit-currency-item__icon" aria-hidden>
                    <span>{category.currency?.slice(0, 1) || '₮'}</span>
                  </span>
                  <span className="deposit-currency-item__label">{category.label}</span>
                  <span className="deposit-currency-item__chevron" aria-hidden>
                    ›
                  </span>
                </button>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
}
